/* eslint-disable no-return-assign */
/* eslint-disable jsx-a11y/href-no-hash */
import React, { Component } from 'react';
import {
  Grid,
  Pagination,
  Label,
  Card,
  Loader,
  Segment,
  Button,
  Popup,
  Icon,
  Header
} from 'semantic-ui-react';
import { toast } from 'react-toastify';
import AdPrototypeListCard from './AdPrototypeListCard';
import { insertAdPrototype } from '../../../services/AdPrototypeService';
import { changeProtoypeThumbnail } from '../../../utils/thumbnailRecovery';
import {
  returnObjectFromUrlQueryParams,
  updateAdLibraryUrl
} from '../../../utils/urls';
import AdPrototypeSearch from './AdPrototypeSearch';
import './AdPrototypeList.css';

class AdPrototypeList extends Component {
  state = {
    showConfirm: false,
    itemsPerPage: 48,
    isOpen: null,
    copyAdName: '',
    errorMessage: '',
    adPrototypes: [],
    outputQueryObject: {},
    initialOutputQueryObject: {},
    loading: false,
    pagination: {
      activePage: 1,
      boundaryRange: 1,
      siblingRange: 1,
      showEllipsis: true,
      showFirstAndLastNav: true,
      totalPages: 50,
      rowsPerPage: 4
    },
    adLaunchQueue: []
  };

  componentWillMount() {
    this.initializeoutputQueryObject();
  }

  componentDidMount() {
    this.setAdPrototypesState();
  }

  async componentDidUpdate(prevProps) {
    const { qcWasProcessed, getAdPrototypes } = this.props;
    if (!prevProps.qcWasProcessed && qcWasProcessed && getAdPrototypes) {
      await getAdPrototypes();
      this.setAdPrototypesState();
    }
  }

  setAdPrototypesState = () => {
    const {
      adPrototypes: adPrototypesFromProps,
      totalPages: totalPagesFromProps
    } = this.props;
    this.setState(
      (prevState) => ({ ...prevState, loading: true }),
      async () => {
        const updatedAdPrototypes = await this.getThumbnailsForAdPrototypes(
          adPrototypesFromProps
        );
        this.setState({
          ...this.state,
          loading: false,
          adPrototypes: updatedAdPrototypes,
          pagination: {
            ...this.state.pagination,
            totalPages: totalPagesFromProps,
            activePage: 1,
            boundaryRange: 1,
            siblingRange: 1,
            showEllipsis: true,
            showFirstAndLastNav: true,
            rowsPerPage: 4
          }
        });
      }
    );
  };

  getThumbnailsForAdPrototypes = async (adPrototypes) => {
    const { fbToken } = this.props;
    const updatedAdPrototypes = await Promise.all(
      adPrototypes.map(async (adPrototype) => {
        const currentAdPrototype = { ...adPrototype };
        const updatedAdPrototype = await changeProtoypeThumbnail(
          currentAdPrototype,
          fbToken
        );
        const { type, thumbnail } = updatedAdPrototype;
        if (type === 'Carousel' && thumbnail.includes('missingThumbnail')) {
          const recoveredThumbnailFromCard = await this.getAdPrototypeThumbnailFromCard(
            updatedAdPrototype,
            fbToken
          );
          updatedAdPrototype.thumbnail = recoveredThumbnailFromCard;
        }
        return updatedAdPrototype;
      })
    );
    return Promise.resolve(updatedAdPrototypes);
  };

  getAdPrototypeThumbnailFromCard = async (adPrototype, fbToken) => {
    const { adPrototypesCards } = this.props;
    let recoveredThumnail = '';
    const foundCard = adPrototypesCards.find((card) => {
      const { ad_prototype_id: adPrototypeId } = card;
      return adPrototypeId === adPrototype.id;
    });
    if (foundCard) {
      const updatedAdPrototypeCard = await changeProtoypeThumbnail(
        foundCard,
        fbToken
      );
      const { thumbnail } = updatedAdPrototypeCard;
      recoveredThumnail = thumbnail;
    }
    return Promise.resolve(recoveredThumnail);
  };

  renderTags = (adPrototype) => {
    const { client: accountId } = adPrototype;
    const {
      tags: formattedTags,
      accountOptions,
      adPrototypesTags
    } = this.props;
    const formmatedAccountTags = formattedTags.account;
    const foundAccount = accountOptions.find(
      (account) => account.value === accountId
    );
    const { text: accountText } = foundAccount || {};
    const foundFormattedTag =
      accountText && formmatedAccountTags
        ? formmatedAccountTags.find((tag) => tag.value === accountText)
        : {};
    const tags = adPrototypesTags.filter(
      (tag) => tag.ad_prototype_id === adPrototype.id
    );
    if (foundFormattedTag && foundFormattedTag.value) {
      tags.push(foundFormattedTag);
    }

    return (
      <div>
        {tags && tags.length > 0 ? (
          tags.map((tag) => (
            <Label key={`${tag.value}-label`}>{tag.value}</Label>
          ))
        ) : (
          <div>
            <Label>None</Label>
          </div>
        )}
      </div>
    );
  };

  handleNameChange = (event, { value }) => {
    this.setState({ copyAdName: value });
  };

  removeAdPrototype = async () => {
    const { deleteRowId } = this.state;
    const { deleteAdPrototype } = this.props;
    const deleteAdPrototypeResult = await deleteAdPrototype(deleteRowId);
    const { statusCode } = deleteAdPrototypeResult;
    this.setState(
      (prevState) => ({ ...prevState, deleteRowId: null }),
      () => {
        if (statusCode && statusCode === 200) {
          this.refreshAdPrototypesAfterChanges();
          this.forceUpdate();
        }
      }
    );
  };

  openDialog = (id) => {
    this.setState({ showConfirm: true, deleteRowId: id });
  };

  handleCancel = () => {
    this.setState({ showConfirm: false });
  };

  editAdPrototype = (adPrototype) => {
    const { adPrototypesTags, editAdPrototype } = this.props;
    const currentAdPrototype = adPrototype;

    const tags = adPrototypesTags.filter(
      (tag) => tag.ad_prototype_id === adPrototype.id
    );
    currentAdPrototype.tags = tags;
    editAdPrototype(currentAdPrototype);
  };

  copyAdPrototype = async (adPrototype) => {
    const { copyAdName } = this.state;
    const { adPrototypesTags, adPrototypesCards, user } = this.props;
    if (!copyAdName) {
      this.setState({
        errorMessage: 'You must add a name for the Ad Prototype'
      });
      return;
    }

    const tags = adPrototypesTags.filter(
      (tag) => tag.ad_prototype_id === adPrototype.id
    );

    const cards = adPrototypesCards.filter(
      (card) => card.ad_prototype_id === adPrototype.id
    );

    const adPrototypeCopy = {
      ...adPrototype,
      id: null,
      name: copyAdName,
      tags: tags.map((tag) => tag.tag_id),
      footerCopy: adPrototype.footer_text,
      created_by: user.email,
      qc_approved: null
    };

    if (cards) {
      adPrototypeCopy.cards = cards;
    }

    const insertAdPrototypeResult = await insertAdPrototype(adPrototypeCopy);
    const { statusCode, adPrototypeId } = insertAdPrototypeResult;
    this.setState(
      (prevState) => ({
        ...prevState,
        isOpen: null,
        copyAdName: ''
      }),
      () => {
        const copyWasSuccessful = statusCode === 200 && adPrototypeId;
        const message = copyWasSuccessful
          ? 'The Ad Prototype has been copied.'
          : 'Failed to copy ad prototype.';
        const status = copyWasSuccessful ? 'success' : 'error';

        toast[status](message, {
          position: 'bottom-left',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true
        });

        this.fetchAdPrototypes();
      }
    );
  };

  launchAdPrototype = (adPrototype) => {
    const currentAdPrototype = adPrototype;

    const tags = this.props.adPrototypesTags.filter(
      (tag) => tag.ad_prototype_id === adPrototype.id
    );
    currentAdPrototype.tags = tags;
    this.props.launchAdPrototype(currentAdPrototype);
  };

  handleOpen = (adPrototype) => {
    this.setState({
      isOpen: adPrototype.id,
      copyAdName: `${adPrototype.name} - Copy`,
      errorMessage: ''
    });
  };

  handleClose = () => {
    this.setState({ isOpen: null });
  };

  createQueryString = (selectedTags, pagination = null) => {
    const keys = Object.keys(selectedTags).filter(
      (key) => selectedTags[key].length !== 0
    );
    const queryStrings = [];

    for (const key of keys) {
      const currentValue = selectedTags[key];

      if (currentValue instanceof Array) {
        const listQueries = currentValue
          .map((value, index) => `${key}[${index}]=${value}`)
          .join('&');

        queryStrings.push(listQueries);
      } else {
        queryStrings.push(`${key}=${currentValue}`);
      }
    }

    if (pagination) {
      const { activePage, rowsPerPage } = pagination;

      queryStrings.push(`activePage=${activePage}`);
      queryStrings.push(`rowsPerPage=${rowsPerPage}`);
    }
    return `?${queryStrings.join('&')}`;
  };

  onPageChange = (event, { activePage }) => {
    this.setState(
      {
        ...this.state,
        pagination: {
          ...this.state.pagination,
          activePage
        }
      },
      () => {
        const urlParamsObject = {
          ...returnObjectFromUrlQueryParams(),
          page: activePage
        };
        updateAdLibraryUrl(urlParamsObject);
        this.fetchAdPrototypes();
      }
    );
  };

  initializeoutputQueryObject = () => {
    const { initialOutputQueryObject } = this.props;
    this.setState((prevState) => ({
      ...prevState,
      initialOutputQueryObject
    }));
  };

  fetchAdPrototypes = (outputQueryObject) => {
    let outputQueryObjectToUse = {};
    const {
      pagination,
      initialOutputQueryObject,
      outputQueryObject: outputQueryObjectFromState
    } = this.state;

    const emptyInitQueryObjFromState = this.checkIfObjectIsEmpty(
      initialOutputQueryObject
    );
    const emptyQueryObjFromState = this.checkIfObjectIsEmpty(
      outputQueryObjectFromState
    );
    const emptyOutputQueryObj = this.checkIfObjectIsEmpty(outputQueryObject);

    if (outputQueryObject && !emptyOutputQueryObj) {
      outputQueryObjectToUse = outputQueryObject;
    } else if (outputQueryObjectFromState && !emptyQueryObjFromState) {
      outputQueryObjectToUse = outputQueryObjectFromState;
    } else if (initialOutputQueryObject && !emptyInitQueryObjFromState) {
      outputQueryObjectToUse = initialOutputQueryObject;
    } else {
      const queryObjFromurl = this.returnRecoveredQueryOutputObj();
      outputQueryObjectToUse = queryObjFromurl;
    }

    let query = this.createQueryString(outputQueryObjectToUse, pagination);

    for (let i = 0; i < query.length; i += 1) {
      if (query[i] === '?' && query[i + 1] === '&') {
        query = query.slice(0, i + 1) + query.slice(i + 2);
        break;
      }
    }

    this.setState(
      {
        ...this.state,
        loading: true,
        adPrototypes: [],
        outputQueryObject: outputQueryObjectToUse
      },
      async () => {
        const { getAdPrototypes } = this.props;
        const result = await getAdPrototypes(query, outputQueryObject);
        const { adPrototypes, activePage, totalPages } = result || {};

        const updatedAdPrototypes = await this.getThumbnailsForAdPrototypes(
          adPrototypes
        );
        this.setState({
          ...this.state,
          adPrototypes: updatedAdPrototypes,
          pagination: {
            ...this.state.pagination,
            activePage,
            totalPages
          },
          loading: false
        });
      }
    );
  };

  checkIfObjectIsEmpty = (obj) => {
    if (!obj) {
      return true;
    }
    const keys = Object.keys(obj);
    return keys.length < 1 || keys.filter((key) => obj[key]).length < 1;
  };

  returnRecoveredQueryOutputObj = () => {
    const { tags } = this.props;
    const newOutputQueryObject = {};
    const queryObjFromUrl = returnObjectFromUrlQueryParams();
    const paramKeys = Object.keys(queryObjFromUrl);
    paramKeys.forEach((key) => {
      if (tags[key]) {
        const foundTag = tags[key].find(
          (tag) => tag.value === queryObjFromUrl[key]
        );
        if (!newOutputQueryObject[key]) {
          newOutputQueryObject[key] = [];
        }
        if (foundTag) {
          newOutputQueryObject[key].push(foundTag.id);
        }
      }
    });

    return newOutputQueryObject;
  };

  toggleAdBuilderAdPreviewModal = (adPrototype) => {
    const adPrototypeToShow = adPrototype;
    const { toggleAdBuilderAdPreviewModal, adPrototypesCards } = this.props;
    if (toggleAdBuilderAdPreviewModal) {
      const cards = adPrototypesCards.filter(
        (card) => card.ad_prototype_id === adPrototype.id
      );
      if (cards) {
        adPrototypeToShow.cards = cards;
      }
      toggleAdBuilderAdPreviewModal(adPrototypeToShow);
    }
  };

  alterAdLaunchQueue = (adPrototypeId, addToQueue) => {
    const { adLaunchQueue, adPrototypes } = this.state;
    const { adPrototypesCards } = this.props;
    let newAdLaunchQueue = [...adLaunchQueue];
    if (addToQueue) {
      const foundAdPrototype = adPrototypeId
        ? adPrototypes.find((adPrototype) => adPrototype.id === adPrototypeId)
        : null;
      if (foundAdPrototype) {
        const { type, cards } = foundAdPrototype;
        if (type === 'Carousel' && (!cards || (cards && cards.length <= 0))) {
          const foundAdPrototypeCards = adPrototypesCards
            ? adPrototypesCards.filter(
                (card) => card.ad_prototype_id === adPrototypeId
              )
            : [];
          if (foundAdPrototypeCards && foundAdPrototypeCards.length > 0) {
            foundAdPrototype.cards = foundAdPrototypeCards;
          }
        }
        newAdLaunchQueue.push(foundAdPrototype);
        if (newAdLaunchQueue.length > 14) {
          toast.warn(
            'No more than 15 Ad Prototypes can be launched at a time.',
            {
              position: 'bottom-center',
              autoClose: 4000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true
            }
          );
        }
      }
    } else {
      const foundAdPrototypeIndex =
        adLaunchQueue.length > 1 && adPrototypeId
          ? adLaunchQueue.findIndex(
              (adPrototype) => adPrototype.id === adPrototypeId
            )
          : null;
      if (foundAdPrototypeIndex && foundAdPrototypeIndex !== -1) {
        newAdLaunchQueue.splice(foundAdPrototypeIndex, 1);
      } else {
        newAdLaunchQueue = [];
      }
    }
    this.setState((prevState) => ({
      ...prevState,
      adLaunchQueue: newAdLaunchQueue
    }));
  };

  clearLaunchQueue = () => {
    this.setState(
      (prevState) => ({
        ...prevState,
        adLaunchQueue: []
      }),
      () => {
        toast.error(`Launch queue has been cleared.`, {
          position: 'bottom-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true
        });
      }
    );
  };

  returnIsLaunchQueueFull = () => {
    const { adLaunchQueue } = this.state;
    return adLaunchQueue.length > 14;
  };

  renderMultiAdLaunchButton = () => {
    const { multiAdLaunchEnabled } = this.props;
    if (multiAdLaunchEnabled) {
      const { adLaunchQueue } = this.state;
      const { length: queueLength } = adLaunchQueue || [];
      return (
        <div className="sticky-tools" style={{ right: '1.5em' }}>
          <Segment compact basic>
            {queueLength > 0 ? (
              <Button
                style={{
                  float: 'left',
                  width: '28%',
                  margin: 0
                }}
                circular
                icon="close"
                color="red"
                size="mini"
                onClick={this.clearLaunchQueue}
              />
            ) : null}
            <Popup
              content="Click here to launch your selected prototypes as ads"
              position="top right"
              size="mini"
              trigger={
                <Button
                  color="green"
                  circular
                  style={{
                    float: 'right',
                    width: queueLength > 0 ? '70%' : '100%',
                    margin: 0
                  }}
                  disabled={queueLength <= 0}
                  onClick={this.launchAdsInQueue}
                >
                  <Button.Content>
                    <Icon name="rocket" size="large" />
                  </Button.Content>
                </Button>
              }
            />
            <Label circular size="big" basic floating>
              {queueLength}
            </Label>
          </Segment>
        </div>
      );
    }
    return null;
  };

  launchAdsInQueue = () => {
    const { launchAdsInQueue } = this.props;
    const { adLaunchQueue } = this.state;
    const queueLength = adLaunchQueue.length;
    if (queueLength > 0 && queueLength <= 15 && launchAdsInQueue) {
      launchAdsInQueue(adLaunchQueue);
    } else {
      const errorMessage =
        queueLength > 15
          ? 'No more than 5 Ad Prototypes can be launched at a time.'
          : 'There are no Ad Prototypes selected';
      toast.warn(errorMessage, {
        position: 'bottom-center',
        autoClose: 4000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });
    }
  };

  getPageNumberFromUrl = () => {
    const urlParamsObject = returnObjectFromUrlQueryParams();
    const pageParamValue = urlParamsObject.page;
    const parsedInt = parseInt(pageParamValue, 10);
    return parsedInt;
  };

  render() {
    const {
      tags,
      adTypeSelector,
      fbToken,
      multiAdLaunchEnabled,
      updateAdPrototype: updateAdPrototypeForQc,
      fillTags,
      user
    } = this.props;
    const {
      showConfirm,
      deleteRowId,
      adPrototypes,
      pagination,
      loading,
      isOpen,
      errorMessage,
      copyAdName,
      adLaunchQueue,
      initialOutputQueryObject
    } = this.state;
    const { activePage, totalPages } = pagination;
    const isLaunchQueueFull = this.returnIsLaunchQueueFull();
    const pageFromUrl = this.getPageNumberFromUrl();
    if (adPrototypes) {
      return (
        <div>
          <Grid stackable doubling textAlign="center">
            <Grid.Row columns={1}>
              <Grid.Column>
                <AdPrototypeSearch
                  tags={tags}
                  user={user}
                  createQueryString={this.createQueryString}
                  initialOutputQueryObject={initialOutputQueryObject}
                  setRefreshProtypesHandler={(handlerFunction) =>
                    (this.refreshAdPrototypesAfterChanges = handlerFunction)
                  }
                  fetchAdPrototypes={this.fetchAdPrototypes}
                  setOutputQueryObjInParent={(outputQueryObject) => {
                    this.setState((prevState) => ({
                      ...prevState,
                      outputQueryObject
                    }));
                  }}
                  disabled={loading}
                  fillTags={fillTags}
                  activePage={activePage}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={1}>
              <Grid.Column>
                <div className="new-ad-prototype-link">
                  <a href="#" onClick={adTypeSelector}>
                    CREATE AD +
                  </a>
                </div>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={1}>
              <Grid.Column>
                <Pagination
                  onPageChange={this.onPageChange}
                  activePage={isNaN(pageFromUrl) ? activePage : pageFromUrl}
                  totalPages={totalPages}
                  style={{ marginTop: '1em', marginBottom: '2em' }}
                  disabled={loading}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={1}>
              {loading ? (
                <Grid.Column>
                  <Loader active inline="centered">
                    Getting ad prototypes...
                  </Loader>
                </Grid.Column>
              ) : (
                <Grid.Column>
                  {adPrototypes.length > 0 ? (
                    <Card.Group centered doubling stackable itemsPerRow={4}>
                      {adPrototypes.map((adPrototype) => {
                        return (
                          <AdPrototypeListCard
                            key={`${adPrototype.id}-card`}
                            adPrototype={adPrototype}
                            showConfirm={showConfirm}
                            deleteRowId={deleteRowId}
                            removeAdPrototype={this.removeAdPrototype}
                            handleCancel={this.handleCancel}
                            openDialog={this.openDialog}
                            editAdPrototype={this.editAdPrototype}
                            launchAdPrototype={this.launchAdPrototype}
                            renderTags={this.renderTags}
                            handleOpen={this.handleOpen}
                            isOpen={isOpen}
                            errorMessage={errorMessage}
                            copyAdName={copyAdName}
                            handleNameChange={this.handleNameChange}
                            copyAdPrototype={this.copyAdPrototype}
                            handleClose={this.handleClose}
                            activePage={activePage}
                            totalAdPrototypes={adPrototypes.length}
                            toggleAdBuilderAdPreviewModal={
                              this.toggleAdBuilderAdPreviewModal
                            }
                            alterAdLaunchQueue={this.alterAdLaunchQueue}
                            adLaunchQueue={adLaunchQueue}
                            fbToken={fbToken}
                            multiAdLaunchEnabled={multiAdLaunchEnabled}
                            isLaunchQueueFull={isLaunchQueueFull}
                            updateAdPrototype={updateAdPrototypeForQc}
                          />
                        );
                      })}
                    </Card.Group>
                  ) : (
                    <Segment placeholder basic>
                      <Header icon>
                        <Icon name="search" />
                        No Ad prototypes found.
                      </Header>
                    </Segment>
                  )}
                </Grid.Column>
              )}
            </Grid.Row>
            <Grid.Row columns={1}>
              <Grid.Column>
                <Pagination
                  onPageChange={this.onPageChange}
                  activePage={isNaN(pageFromUrl) ? activePage : pageFromUrl}
                  totalPages={totalPages}
                  style={{ marginTop: '1em', marginBottom: '2em' }}
                  disabled={loading}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
          {this.renderMultiAdLaunchButton()}
        </div>
      );
    }
    return null;
  }
}

export default AdPrototypeList;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/AdLibrary/AdPrototypeList.js